import styled from 'styled-components';

import { Div, SvgContainer } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';

export const Container = styled(SvgContainer)`
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin: 0 auto;
  }
`;

export const Wrapper = styled(Div)`
  background-color: ${colors.lightBlue};
  border-radius: 3px;
  display: inline-flex;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  z-index: 1;

  @media (max-width: ${BREAKPOINTS.tabletMax}px) {
    margin: 20px 0;
  }

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    text-align: center;
    display: flex;
    flex-direction: column;
  }
`;

export const AbsoluteContainer = styled(Div)`
  position: absolute;
  width: 100%;
  top: -790px;
  right: 0;
  bottom: 0;
  left: -637px;

  @media (max-width: ${BREAKPOINTS.widescreenMin}px) {
    left: -769px;
  }

  @media (max-width: ${BREAKPOINTS.tabletMax}px) {
    top: -784px;
    left: -711px;
  }

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    top: -730px;
    left: -679px;
  }
`;
